<template>
  <div>
    <!-- Openable Area Ventilator table -->
    <table class="ventilator__openable-table">
      <thead>
        <tr class="table-heading-venti3C">
          <td colspan="10">Ventilator Openable Area</td>
        </tr>
        <tr>
          <td style="background-color:#dedede" colspan="2">Orientation</td>
          <!-- <td></td> -->
          <td style="background-color:#dedede" v-for="(venti, m) in step3C.ventilatorArrObj" :key="venti.orientation">{{ venti.orientation }}</td>
        </tr>
        <tr>
          <td colspan="2" style="background-color:#dedede">WWR orientation-wise</td>
          <!-- <td style="background-color:#dedede"></td> -->
          <td style="background-color: #c4def5" v-for="(venti, m) in step3C.ventilatorArrObj" :key="venti.orientation">{{ venti.inputWwrOrientationPercent }}</td>
        </tr>
        <tr>
          <td style="background-color:#dedede">Opening area</td>
          <td style="background-color:#dedede">sq.M</td>
          <td v-for="(venti, m) in step3C.ventilatorArrObj" :key="venti.orientation">{{ venti.calcOpeningArea }}</td>
        </tr>
        <tr>
          <td style="background-color:#dedede">Glass area</td>
          <td style="background-color:#dedede">100%</td>
          <td v-for="(venti, m) in step3C.ventilatorArrObj" :key="venti.orientation">{{ venti.calcGlassArea }}</td>
        </tr>
        <tr>
          <td style="background-color:#dedede">Openable area</td>
          <td style="background-color:#dedede">90%</td>
          <td v-for="(venti, m) in step3C.ventilatorArrObj" :key="venti.orientation">{{ venti.calcOpenableArea }}</td>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <!-- Openable Area Door Table -->
    <table class="ventilator__openable-table">
      <thead>
        <tr class="table-heading-venti3C">
          <td colspan="10">Door Openable Area</td>
        </tr>
        <tr>
          <td style="background-color:#dedede" colspan="2">Orientation</td>
          <!-- <td></td> -->
          <td style="background-color:#dedede" v-for="(door, k) in step3C.doorArrObj" :key="door.orientation">{{ door.orientation }}</td>
        </tr>
        <tr>
          <td colspan="2" style="background-color:#dedede">% Door Area orientation-wise</td>
          <!-- <td style="background-color:#dedede"></td> -->
          <td style="background-color: #c4def5" v-for="(door, k) in step3C.doorArrObj" :key="door.orientation">{{ door.inputWwrOrientationPercent }}</td>
        </tr>
        <tr>
          <td style="background-color:#dedede">Opening area</td>
          <td style="background-color:#dedede">sq.M</td>
          <td v-for="(door, k) in step3C.doorArrObj" :key="door.orientation">{{ door.calcOpeningArea }}</td>
        </tr>
        <tr>
          <td style="background-color:#dedede">Opaque area</td>
          <td style="background-color:#dedede">100%</td>
          <td v-for="(door, k) in step3C.doorArrObj" :key="door.orientation">{{ door.calcOpaqueArea }}</td>
        </tr>
        <tr>
          <td style="background-color:#dedede">Openable area</td>
          <td style="background-color:#dedede">90%</td>
          <td v-for="(door, k) in step3C.doorArrObj" :key="door.orientation">{{ door.calcOpenableArea }}</td>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
  </div>
</template>

<script>
export default {
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step3A: {
      get: function() {
        return this.$store.state.schema.inputs.step3A;
      },
      set: function(step3A) {
        this.$store.dispatch('setStep3A', step3A);
      },
    },
    step3C: {
      get: function() {
        return this.$store.state.schema.inputs.step3C;
      },
      set: function(step3C) {
        this.$store.dispatch('setStep3C', step3C);
      },
    },
  },
};
</script>

<style lang="scss">
.ventilator__openable-table {
  padding: 12px;
  width: 100%;
  font-size: 12px;
  // border: 1px solid #a4abb3;
  border-spacing: 0px;
  .table-heading-venti3C {
    background-color: #c4def5;
    padding: 4px;
    font-size: 16px;
    background-color: #c8f0e0;
    color: #2cb17c;
  }
  td {
    border: 1px solid #a4abb3;
    border-spacing: 0px;
    padding: 2px;
    text-align: center;
  }
}
</style>
